import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/reddit-alien': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M440.3 203.5c55.3 0 73.7 74.1 23.8 99.7 2.2 7.9 3.1 16.7 3.1 25.1 0 83.8-94.4 151.7-210.8 151.7-115.9 0-210.3-67.9-210.3-151.7 0-8.4 0.8-16.8 2.6-24.7-50.9-25.5-32.7-100.1 22.9-100.1 15 0 28.7 6.2 38.4 16.3 35.8-24.7 83.4-40.6 136.3-42.8l30.4-137.6c1.3-4.9 6.1-8.4 11-7.1l97.4 21.6c6.6-12.7 19.9-22 35.3-22 22.1 0 39.7 18.1 39.7 39.7 0 21.6-17.7 39.7-39.7 39.7-21.6 0-39.2-17.6-39.2-39.2l-88.2-19.8-27.7 124.8c53.3 1.7 101.4 17.6 137.1 42.3 9.7-9.7 22.9-15.9 37.9-15.9zM129.4 308.9c0 21.6 17.7 39.3 39.7 39.2 21.6 0 39.2-17.6 39.2-39.2 0-22.1-17.6-39.7-39.2-39.7-22.1 0-39.7 17.7-39.7 39.7zM343.7 402.4c4-3.5 4-9.7-0.1-13.7-3.5-3.5-9.7-3.5-13.2 0-29 29-121.2 28.5-149 0-3.5-3.5-9.7-3.5-13.2 0-4 4-4 10.2 0 13.7 36.4 36.4 139.1 36.4 175.5 0zM342.9 348.2c22 0 39.6-17.7 39.7-39.2 0-22.1-17.7-39.7-39.7-39.7-21.6 0-39.2 17.7-39.2 39.7 0 21.6 17.6 39.2 39.2 39.2z'
      }
    ]
  }
})
